import Cookies from 'js-cookie';

export const getUserSegment = () => parseInt(Cookies.get('xf_seg') || 0, 10) || 0;

export default getUserSegment;
